/* sg-expo-hero: elige la fase vigente y anima el contador. Las fechas vienen de data-end en cada fase. */
if (!customElements.get('sg-expo-hero')) {
  class SgExpoHero extends HTMLElement {
    connectedCallback() {
      this.phases = [...this.querySelectorAll('[data-sg-phase]')].map((el) => ({
        el,
        end: el.dataset.end ? Date.parse(el.dataset.end) : Infinity,
      }));
      this.endedEl = this.querySelector('[data-sg-ended]');
      // Corrige el desfase entre el reloj del servidor y el del visitante.
      this.skew = this.dataset.serverNow ? Number(this.dataset.serverNow) * 1000 - Date.now() : 0;
      this.current = undefined;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    now() {
      return Date.now() + this.skew;
    }

    tick() {
      const now = this.now();
      const index = this.phases.findIndex((p) => p.end > now);
      if (index !== this.current) this.show(index);
      if (index === -1) return clearInterval(this.timer);

      const remaining = Math.max(0, this.phases[index].end - now);
      const total = Math.floor(remaining / 1000);
      const parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      const root = this.phases[index].el;
      Object.entries(parts).forEach(([unit, value]) => this.setUnit(root, unit, value));
    }

    show(index) {
      this.current = index;
      this.phases.forEach((p, i) => (p.el.hidden = i !== index));
      if (this.endedEl) this.endedEl.hidden = index !== -1;
      this.dataset.ended = String(index === -1);
    }

    setUnit(root, unit, value) {
      const tile = root.querySelector(`[data-sg-cd="${unit}"]`);
      if (!tile) return;
      const text = String(value).padStart(2, '0');
      const num = tile.querySelector('.sg-cd__num');
      if (num.textContent === text) return;
      const first = num.textContent === '00' && !tile.dataset.ready;
      num.textContent = text;
      tile.dataset.ready = 'true';
      if (first) return;
      tile.classList.remove('is-tick');
      void tile.offsetWidth;
      tile.classList.add('is-tick');
    }
  }

  customElements.define('sg-expo-hero', SgExpoHero);
}
